/*
 * @Author: 17388316638 lemon1234..
 * @Date: 2022-09-16 11:38:02
 * @LastEditors: 17388316638 lemon1234..
 * @LastEditTime: 2022-09-16 11:40:56
 * @FilePath: \qcsdjyBigdataUI\src\api\api1.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/tool/request";
const api1 = {
  //视频监控列表
  monitorList(params) {
    return request({
      url: "/qdBigData/monitor/monitorList",
      method: "get",
      params,
    });
  },
  //视频监控总数
  videoMonitoringCount(params) {
    return request({
      url: "/qdBigData/monitor/videoMonitoringCount",
      method: "get",
      params,
    });
  },
  //非遗总数
  intangibleProjectCount(params) {
    return request({
      url: "/qdBigData/intangible/intangibleProjectCount",
      method: "get",
      params,
    });
  },
  //非遗项目级别
  intangibleLevelList(params) {
    return request({
      url: "/qdBigData/intangible/intangibleLevelList",
      method: "get",
      params,
    });
  },
  //非遗项目列表
  intangibleList(params) {
    return request({
      url: "/qdBigData/intangible/intangibleList",
      method: "get",
      params,
    });
  },
  //非遗项目分类分布
  intangibleTypeList(params) {
    return request({
      url: "/qdBigData/intangible/intangibleTypeList",
      method: "get",
      params,
    });
  },
  //通过id查询非遗传承项目
  getIntangibleProjectById(params) {
    return request({
      url: "/qdBigData/intangible/getIntangibleProjectById",
      method: "get",
      params,
    });
  },
  //计算酒店总数
  hotelCount(params) {
    return request({
      url: "/qdBigData/hotel/hotelCount",
      method: "get",
      params,
    });
  },
  //酒店列表
  hotelList(params) {
    return request({
      url: "/qdBigData/hotel/hotelList",
      method: "get",
      params,
    });
  },
  //计算古树总数
  treeCount(params) {
    return request({
      url: "/qdBigData/tree/treeCount",
      method: "get",
      params,
    });
  },
  //古树各等级
  treeGrade(params) {
    return request({
      url: "/qdBigData/tree/treeGrade",
      method: "get",
      params,
    });
  },
  //古树top10
  subjectRanking(params) {
    return request({
      url: "/qdBigData/tree/subjectRanking",
      method: "get",
      params,
    });
  },
  //交通卡口
  trafficList(params) {
    return request({
      url: "/qdBigData/traffic/trafficList",
      method: "get",
      params,
    });
  },
  //重点交通卡口
  focusTrafficList(params) {
    return request({
      url: "/qdBigData/traffic/focusTrafficList",
      method: "get",
      params,
    });
  },
  //文物等级、总数
  culturalLevelList(params) {
    return request({
      url: "/qdBigData/cultural/culturalLevelList",
      method: "get",
      params,
    });
  },
  //文物列表
  culturalList(params) {
    return request({
      url: "/qdBigData/cultural/culturalList",
      method: "get",
      params,
    });
  },
  //文物类型
  culturalTypeList(params) {
    return request({
      url: "/qdBigData/cultural/culturalTypeList",
      method: "get",
      params,
    });
  },
  //古树名木区域分布
  areaDistribution(params) {
    return request({
      url: "/qdBigData/tree/areaDistribution",
      method: "get",
      params,
    });
  },
  //古树名木区域分布
  areaDistribution(params) {
    return request({
      url: "/qdBigData/tree/areaDistribution",
      method: "get",
      params,
    });
  },
  //古树名木列表
  treeList(params) {
    return request({
      url: "/qdBigData/tree/treeList",
      method: "get",
      params,
    });
  },
  //全域大数据------------------

  //过夜游客分区分析
  overNightGroupAnalysis(params) {
    return request({
      url: "/qdBigData/globalFlow/overNightGroupAnalysis",
      method: "get",
      params,
    });
  },
  //酒店游客分析
  hotelVisitorAnalysis(params) {
    return request({
      url: "/qdBigData/globalFlow/hotelVisitorAnalysis",
      method: "get",
      params,
    });
  },
  //全域流量分析
  globalFlow(params) {
    return request({
      url: "/qdBigData/globalFlow/globalFlow",
      method: "get",
      params,
    });
  },
  //热门旅游景点客流排名
  hotScenicRanked(params) {
    return request({
      url: "/qdBigData/globalFlow/hotScenicRanked",
      method: "get",
      params,
    });
  },
  //客流数据分析
  scenicPeople(params) {
    return request({
      url: "/qdBigData/globalFlow/scenicPeople",
      method: "get",
      params,
    });
  },
  //客源地分析
  countryCount(params) {
    return request({
      url: "/qdBigData/globalSource/countryCount",
      method: "get",
      params,
    });
  },
  sourceAnalyse(params) {
    return request({
      url: "/qdBigData/globalSource/sourceAnalyse",
      method: "get",
      params,
    });
  },
  //本年全域累计客流量
  mobileYearsData(params) {
    return request({
      url: "/qdBigData/global/mobileYearsData",
      method: "get",
      params,
    });
  },
  //游客画像(性别)
  genderList(params) {
    return request({
      url: "/qdBigData/globalImage/genderList",
      method: "get",
      params,
    });
  },
  //游客画像(年龄)
  ageList(params) {
    return request({
      url: "/qdBigData/globalImage/ageList",
      method: "get",
      params,
    });
  },

  // 游客画像(票务数据)
  ageListByTicket(params) {
    return request({
      url:"/qdBigData/globalImage/ticketAgeList",
      method: "get",
      params,
    });
  },

  //游客重游分析
  revisitCount(params) {
    return request({
      url: "/qdBigData/global/revisitCount",
      method: "get",
      params,
    });
  },
  //实时客流总数
  mobilePeople(params) {
    return request({
      url: "/qdBigData/globalFlow/globalPeople",
      method: "get",
      params,
    });
  },
  //景区过夜人数(日期)
  overnightList(params) {
    return request({
      url: "/qdBigData/globalImage/overnightList",
      method: "get",
      params,
    });
  },
  //出行方式分析
  travelMonthCount(params) {
    return request({
      url: "/qdBigData/globalSource/travelMonthCount",
      method: "get",
      params,
    });
  },
  //全省自驾排行
  provinceSelfDrivingRanking(params) {
    return request({
      url: "/qdBigData/global/provinceSelfDrivingRanking",
      method: "get",
      params,
    });
  },
  //周边旅游相关
  travelUrlCount(params) {
    return request({
      url: "/qdBigData/globalFlow/travelUrlCount",
      method: "get",
      params,
    });
  },
  //省内自驾来源日分析
  siChuanTouristsSourceDayTop10(params) {
    return request({
      url: "/qdBigData/globalSource/siChuanTouristsSourceDayTop10",
      method: "get",
      params,
    });
  },
  //省内自驾来源月分析
  siChuanTouristsSourceMonthTop10(params) {
    return request({
      url: "/qdBigData/globalSource/siChuanTouristsSourceMonthTop10",
      method: "get",
      params,
    });
  },
  //省内自驾来源年分析
  siChuanTouristsSourceYearTop10(params) {
    return request({
      url: "/qdBigData/globalSource/siChuanTouristsSourceYearTop10",
      method: "get",
      params,
    });
  },
  //省外自驾来源日分析
  wholeCountryTouristsSourceDayTop10(params) {
    return request({
      url: "/qdBigData/globalSource/wholeCountryTouristsSourceDayTop10",
      method: "get",
      params,
    });
  },
  //省外自驾来源月分析
  wholeCountryTouristsSourceMonthTop10(params) {
    return request({
      url: "/qdBigData/globalSource/wholeCountryTouristsSourceMonthTop10",
      method: "get",
      params,
    });
  },
  //省外自驾来源年分析
  wholeCountryTouristsSourceYearTop10(params) {
    return request({
      url: "/qdBigData/globalSource/wholeCountryTouristsSourceYearTop10",
      method: "get",
      params,
    });
  },
  //自驾游日趋势
  thisMonthTouristsSource(params) {
    return request({
      url: "/qdBigData/globalSource/thisMonthTouristsSource",
      method: "get",
      params,
    });
  },
  //自驾游月趋势
  yearTouristsSource(params) {
    return request({
      url: "/qdBigData/globalSource/yearTouristsSource",
      method: "get",
      params,
    });
  },
  //自驾游年趋势
  allTouristsSourceByYear(params) {
    return request({
      url: "/qdBigData/globalSource/allTouristsSourceByYear",
      method: "get",
      params,
    });
  },
  //游客画像------------------
  //一日平均驻留时长
  stayTimeList(params) {
    return request({
      url: "/qdBigData//globalImage/stayTimeList",
      method: "get",
      params,
    });
  },
  //停留天数分析
  stayDayList(params) {
    return request({
      url: "/qdBigData/globalImage/stayDayList",
      method: "get",
      params,
    });
  },
  //热门线路
  hotRoute(params) {
    return request({
      url: "/qdBigData/globalFlow/hotRoute",
      method: "get",
      params,
    });
  },
  //旅游消费--------------------------------
  //消费规模统计(月)
  consumptionScaleStatistics(params) {
    return request({
      url: "/qdBigData/globalConsumption/consumptionScaleStatistics",
      method: "get",
      params,
    });
  },
  //旅游消费分布
  industryConsumeMonth(params) {
    return request({
      url: "/qdBigData/globalConsumption/industryConsumeMonth",
      method: "get",
      params,
    });
  },
  //旅游消费同比
  industryConsumeRate(params) {
    return request({
      url: "/qdBigData/globalConsumption/industryConsumeRate",
      method: "get",
      params,
    });
  },
  //消费排名
  getTourismConsumption(params) {
    return request({
      url: "/qdBigData/globalConsumption/getTourismConsumption",
      method: "get",
      params,
    });
  },
  //客单价
  industryConsumeStatistics(params) {
    return request({
      url: "/qdBigData/globalConsumption/industryConsumeStatistics",
      method: "get",
      params,
    });
  },
  //消费指数分析
  getConsumptionIndex(params) {
    return request({
      url: "/qdBigData/globalConsumption/getConsumptionIndex",
      method: "get",
      params,
    });
  },
  //月消费总额
  monthlyConsumptionTotal(params) {
    return request({
      url: "/qdBigData/globalConsumption/monthlyConsumptionTotal",
      method: "get",
      params,
    });
  },
  //均比消费
  getAverageConsumption(params) {
    return request({
      url: "/qdBigData/globalConsumption/getAverageConsumption",
      method: "get",
      params,
    });
  },
  //中间片区消费统计
  getAreaStatistics(params) {
    return request({
      url: "/qdBigData/globalConsumption/getAreaStatistics",
      method: "get",
      params,
    });
  },
  //智游青城山----------------------------
  //商家类型占比
  businessCount(params) {
    return request({
      url: "/qdBigData/globalQcs/businessCount",
      method: "get",
      params,
    });
  },
  //商家总数
  merchantCount(params) {
    return request({
      url: "/qdBigData/globalQcs/merchantCount",
      method: "get",
      params,
    });
  },
  //用户登录人数
  loginCount(params) {
    return request({
      url: "/qdBigData/globalQcs/loginCount",
      method: "get",
      params,
    });
  },
  //uv,pv
  cappVisitCount(params) {
    return request({
      url: "/qdBigData/globalQcs/cappVisitCount",
      method: "get",
      params,
    });
  },
  //销售品类排
  productRevenueCount(params) {
    return request({
      url: "/qdBigData/globalQcs/productRevenueCount",
      method: "get",
      params,
    });
  },
  //销售品类排
  productRevenueCount(params) {
    return request({
      url: "/qdBigData/globalQcs/productRevenueCount",
      method: "get",
      params,
    });
  },
  //累计用户总数月累计用户注册数
  userAnalysisCount(params) {
    return request({
      url: "/qdBigData/globalQcs/userAnalysisCount",
      method: "get",
      params,
    });
  },
  //订单总数
  monthOrderCount(params) {
    return request({
      url: "/qdBigData/globalQcs/monthOrderCount",
      method: "get",
      params,
    });
  },
  //交易情况分析
  realTimeSales(params) {
    return request({
      url: "/qdBigData/globalQcs/realTimeSales",
      method: "get",
      params,
    });
  },
  //栏目调整率分析
  systemAccessCount(params) {
    return request({
      url: "/qdBigData/globalQcs/systemAccessCount",
      method: "get",
      params,
    });
  },
  //退款单数和金额
  refundOrderCount(params) {
    return request({
      url: "/qdBigData/globalQcs/refundOrderCount",
      method: "get",
      params,
    });
  },
  //今日重游客流列表
  revisitDay(params) {
    return request({
      url: "/qdBigData/revisit/day",
      method: "get",
      params,
    });
  },
  revisitMonth(params) {
    return request({
      url: "/qdBigData/revisit/month",
      method: "get",
      params,
    });
  },
  revisitYear(params) {
    return request({
      url: "/qdBigData/revisit/year",
      method: "get",
      params,
    });
  },
  //本年重游客
  thisYearRevisit(params) {
    return request({
      url: "/qdBigData/revisit/thisYearRevisit",
      method: "get",
      params,
    });
  },
  //今日重游客
  todayRevisit(params) {
    return request({
      url: "/qdBigData/revisit/todayRevisit",
      method: "get",
      params,
    });
  },
};
export default api1;
